import { NgClass } from '@angular/common';
import { Component, EventEmitter, output, Output, signal } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-overseas-popup',
  imports: [NgClass],
  templateUrl: './overseas-popup.html',
  styleUrl: './overseas-popup.scss'
})
export class OverseasPopupComponent {
  isBangla = signal<boolean> (true);
  isVisible = signal<boolean> (false);
  modalClose = output<void>()
  environment = environment;
  close(){
      this.isVisible.set(false);
      this.modalClose.emit();
  }
}
